import { useState } from "react";
import DialogFormPanel from "../../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../../shared/components/button/CreateButtonTrigger";
import CreateDataApiPermissionForm from "./CreateDataApiPermissionForm";

const CreateDataApiPermissionDialog = ({
  onSubmitHandler,
  roles,
  datasets,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="Alta nuevo permiso"
      description="Crear un nuevo permiso en Data API"
      content={
        <CreateDataApiPermissionForm
          onSubmitHandler={onSubmit}
          roles={roles}
          datasets={datasets}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateDataApiPermissionDialog;
